import { Model, ResourceFactory } from '../services/';

class Log extends Model {
  public username: string = '';
  public useremail: string = '';
  public name: string = '';
  public operation: string = '';
  public type: string = '';
  public object_id: number;
  public created_at: string = '';
}

const LogFactory = ResourceFactory.create<Log>(Log, 'log');

export { Log, LogFactory };